import { Component, Input, EventEmitter, Output, AfterViewInit, ViewChild, ElementRef, input } from '@angular/core';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-add-product-button',
  templateUrl: './add-product-button.component.html',
  styleUrls: ['./add-product-button.component.scss'],
  imports: [NgClass, MatIcon],
})
export class AddProductButtonComponent implements AfterViewInit {
  IconNames = IconNames;

  testId = input.required<string>();
  @Input({ required: true }) iconName: IconNames;
  @Input({ required: true }) buttonText: string;
  @Input() isDisabled: boolean;
  @Input() buttonCategory: 'primary' | 'secondary' = 'primary';
  @Input() focusOnInit: boolean = true;

  @Output() add: EventEmitter<void> = new EventEmitter();

  @ViewChild('button') button: ElementRef;
  ngAfterViewInit() {
    if (this.focusOnInit && !this.isDisabled) {
      this.button.nativeElement.focus();
    }
  }
}
